import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateStatusInventory = createAction(ACTION.UPDATE_STATUS_INVENTORY.REQUEST, (data) => ({data}));
